import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PODS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getPodAction = createAsyncThunk(
    'pod/getPodAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PODS_PATH }/${ data.id }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getPodSlice = createSlice({
    name: 'getPodSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidatePod() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getPodAction.pending, () => STATE__API__STARTED);
        builder.addCase(getPodAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getPodAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidatePod } = getPodSlice.actions;
export const getPodState = (state) => state.pod.getPod;
export default getPodSlice.reducer;
